// @core/api/endpoints/booking/get_booking.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BookingResponse,
} from '../../../types/booking';

const BASE_PATH = '/booking';

/**
 * Get booking
 * Returns full booking details including payment references and linked resources.
 */
export async function GetBooking(
  booking_id: string,
  options?: RequestOptions
): Promise<BookingResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/bookings/:booking_id`;
  requestPath = requestPath.replace(':booking_id', encodeURIComponent(booking_id));
  const requestOptions = options;
  return client.get<BookingResponse>(requestPath, { ...requestOptions });
}
